import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, Fragment as _Fragment, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "sticky-header" }
const _hoisted_2 = { class: "flex justify-content-between align-items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "m-0 py-4" }, "Settings", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_config_content = _resolveComponent("config-content")!
  const _component_Sidebar = _resolveComponent("Sidebar")!
  const _component_router_view = _resolveComponent("router-view")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Button, {
      class: "p-button-rounded p-button-raised fab",
      icon: "ri-settings-2-line",
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.isSidebarVisible = true))
    }),
    _createVNode(_component_Sidebar, {
      visible: _ctx.isSidebarVisible,
      "onUpdate:visible": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.isSidebarVisible) = $event)),
      baseZIndex: 1000,
      position: "right",
      class: "p-sidebar-md",
      showCloseIcon: false,
      modal: false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", null, [
              _createVNode(_component_Button, {
                label: "Close",
                class: "p-button-text p-button-sm",
                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.isSidebarVisible = false))
              }),
              _createVNode(_component_Button, {
                label: "Export",
                icon: "ri-download-line",
                class: "p-button-sm ml-2",
                onClick: _ctx.exportImage
              }, null, 8, ["onClick"])
            ])
          ]),
          (_ctx.isExporting)
            ? (_openBlock(), _createBlock(_component_ProgressBar, {
                key: 0,
                mode: "indeterminate",
                style: {"height":"0.5em","width":"100%"}
              }))
            : _createCommentVNode("", true)
        ]),
        _createVNode(_component_config_content)
      ]),
      _: 1
    }, 8, ["visible"]),
    _createVNode(_component_router_view)
  ], 64))
}